import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIconWarningRoundedFilledSmall = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 32 32" aria-hidden={!title && !titleId} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M16 2.667c7.364 0 13.333 5.969 13.333 13.333S23.363 29.333 16 29.333 2.667 23.363 2.667 16 8.637 2.667 16 2.667m-.001 16.684A2.177 2.177 0 1 0 16 23.706a2.177 2.177 0 0 0 0-4.356m0-11.644c-1.11 0-1.99.933-1.926 2.04v.004l.402 6.02a1.527 1.527 0 0 0 3.047 0l.403-6.02v-.004A1.93 1.93 0 0 0 16 7.706" /></svg>;
export default SvgIconWarningRoundedFilledSmall;